import { Button, Icon } from "@nexus/ui";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { buildPublicScriptShareUrl } from "@/features/marketplace/lib/public-script-url";
import { useCopyToClipboard } from "@/hooks/useCopyToClipboard";

export function PartnerPublicScriptLink({
  scriptId,
  origin = typeof window !== "undefined" ? window.location.origin : "",
}: {
  scriptId: string;
  origin?: string;
}) {
  const { t } = useTranslation();
  const url = buildPublicScriptShareUrl(scriptId, origin);
  const copiedMessage = t(
    "marketplace.partner.workspace.publicLinkCopied",
    "Public script link copied",
  );
  const copyLabel = t(
    "marketplace.partner.workspace.copyPublicLink",
    "Copy public script link",
  );
  const { copied, copy } = useCopyToClipboard({
    onCopy: () => toast.success(copiedMessage),
  });

  return (
    <div className="flex min-w-0 items-center gap-0.5">
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex min-h-7 items-center gap-1.5 text-sm font-medium text-primary hover:text-primary/80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40"
      >
        <Icon name="external-link" size="sm" color="inherit" aria-hidden />
        {t("marketplace.partner.workspace.publicScript", "Public script")}
      </a>
      <Button
        type="button"
        variant="ghost"
        size="icon-sm"
        aria-label={copied ? copiedMessage : copyLabel}
        className="shrink-0 text-muted-foreground hover:text-foreground"
        onClick={() => {
          void copy(url);
        }}
      >
        <Icon name={copied ? "check" : "copy"} size="sm" color="inherit" />
      </Button>
    </div>
  );
}
